//
import { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchOTP } from "app/auth/authFetchOTPSlice";
import { getProfile } from "app/auth/authSlice";
//
//
const usePageLogin = (onCloseModalQuickView) => {
  const dispatch = useDispatch();
  //
  const [otp, setOtp] = useState();
  const [number, setPhone] = useState();
  const [err, setErr] = useState("");
  //
  const handleGetProfile = (e) => {
    //
    e.preventDefault();
    if (number === undefined || otp === undefined)
      setErr("Fields are required !");
    else
      dispatch(
        getProfile({
          number: number,
          otp: otp,
          onCloseModalQuickView: onCloseModalQuickView,
        })
      );
  };

  const handleOtpChange = (otpValue) => {
    setOtp(otpValue);
  };

  const handleOTP = (e) => {
    e.preventDefault();
    if (number === undefined) setErr("Phone number cannot be empty!");
    else if (number < 13) setErr("phone number cannot be less than 10 digit");
    else dispatch(fetchOTP(number));
  };

  const handlePhone = (e) => {
    if (e === undefined || "") setErr("Phone number cannot be empty!");
    else if (e?.length > 0) setErr("");
    else if (e?.length > 12)
      setErr("Phone number cannot be more than 10 digit");
    setPhone(e);
  };

  return {
    number,
    setPhone,
    setOtp,
    otp,
    handleGetProfile,
    handleOtpChange,
    handleOTP,
    handlePhone,
    err,
    setErr,
  };
};

export default usePageLogin;
